import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import MultinationalTabs from '../../../../components/MultinationalTabs';
import TextEditor from '../../../../components/TextEditor/TextEditor';
import { clientTermsAndPrivacy } from '../../../../redux/slices/clientsSlice';

export default function SpecificTerms({ data, onChangeMultinational, excludedCodes, onSave }) {
    const termsAndPrivacy = useSelector(clientTermsAndPrivacy);
    const countriesLocalizationsData = useMemo(
        () =>
            termsAndPrivacy?.policy?.reduce((acc, el) => {
                acc[el.country_code] = { terms_of_use: el.terms_of_use };
                return acc;
            }, {}),
        [termsAndPrivacy],
    );
    return (
        <MultinationalTabs excludedCodes={excludedCodes}>
            <TextEditor
                onChange={onChangeMultinational}
                data={data}
                onSave={onSave}
                currentPage="terms_of_use"
                title="Terms of Use"
                initialData={countriesLocalizationsData}
            />
        </MultinationalTabs>
    );
}
